import {mapActions, mapGetters} from "vuex";
import { debounce } from 'lodash'


export default {
    computed: {
        ...mapGetters({
            currentUserRoleId: 'e/users/currentUserRoleId',
            currentPositionId: 'e/users/currentPositionId',
            currentOrganizationId: 'e/users/currentOrganizationId',
        }),

    },
    methods: {
        contextChangedListener: debounce(function() {
            this.contextChangedHandler()
        }, 100),
        contextChangedHandler() {

        }
    },
    watch: {
        currentPositionId() {
            this.contextChangedListener()
        },
        currentOrganizationId() {
            this.contextChangedListener()
        },
    }
}
